<template>
  <study-plan-set-modal
    :open="state.visible"
    :course-title="state.courseTitle"
    :word-count="state.wordCount"
    :sentence-count="state.sentenceCount"
    :type-list="state.typeList"
    :allow-skip="state.allowSkip"
    :default-daily-learn="state.defaultDailyLearn"
    :default-daily-review="state.defaultDailyReview"
    @confirm="onConfirm"
    @skip="onSkip"
    @cancel="onCancel"
  />
</template>

<script>
import StudyPlanSetModal from '@/components/StudyPlanSetModal.vue'
import {
  getStudyPlanGateState,
  confirmStudyPlanGate,
  skipStudyPlanGate,
  cancelStudyPlanGate
} from '@/utils/studyPlanGate'

export default {
  name: 'StudyPlanSetHost',
  components: { StudyPlanSetModal },
  setup () {
    return {
      state: getStudyPlanGateState()
    }
  },
  methods: {
    onConfirm (plan) {
      confirmStudyPlanGate(plan)
    },
    onSkip () {
      skipStudyPlanGate()
    },
    onCancel () {
      cancelStudyPlanGate()
    }
  }
}
</script>
